// Constants
import { APP_CONFIG } from '../constants';

export const extractSplashInfo = ( isWeb ) => {

    return isWeb ?
        APP_CONFIG.SPLASH.WEB : APP_CONFIG.SPLASH.MOBILE;
}